import "./style.scss";

import * as Sentry from "@sentry/react";
import { useEffect, useState } from "react";
import type { TFunction } from "react-i18next";
import { Link, useRouteError } from "react-router-dom";

export default function ErrorBoundary({
    children,
    translate,
}: {
    children: JSX.Element;
    translate: TFunction<"translation", undefined>;
}) {
    const [hasError, setHasError] = useState(true);

    const error = useRouteError() as Error;
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    if (hasError) {
        return (
            <div className="error-boundary-container">
                <h2 className="error-boundary-title">{translate("ErrorBoundary.ErrorOccured")}</h2>
                <p className="error-boundary-subtitle">{translate("ErrorBoundary.SorryForInconvenience")}</p>
                <Link to={"/"} className="error-boundary-link" onClick={() => setHasError(false)}>
                    {translate("ErrorBoundary.ReturnToIndex")}
                </Link>
            </div>
        );
    } else {
        return children;
    }
}
